import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { usePortalTour } from '../../context/PortalTourContext';
import { usePortalHelp } from '../../context/PortalHelpContext';
import { useAuth } from '../../context/AuthContext';

export default function PortalTourHelpButton() {
  const { startTour, clearTourProgress, TOUR_IDS } = usePortalTour();
  const { openHelp, pageHelp } = usePortalHelp();
  const { isAuditor } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const openPageHelp = () => {
    setMenuOpen(false);
    window.setTimeout(() => openHelp({ tab: 'guide' }), 0);
  };

  const runOverview = () => {
    setMenuOpen(false);
    window.setTimeout(() => startTour(TOUR_IDS.overview, { force: true }), 0);
  };

  const runPayroll = () => {
    if (isAuditor()) return;
    setMenuOpen(false);
    window.setTimeout(() => startTour(TOUR_IDS.payroll, { force: true }), 0);
  };

  const resetForNewStaffOnThisPc = () => {
    setMenuOpen(false);
    clearTourProgress(null);
    window.setTimeout(() => startTour(TOUR_IDS.overview, { force: true }), 0);
  };

  return (
    <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="rounded-xl border-[#E4E8EB]"
          data-tour="portal-help-tour"
        >
          <HelpCircle className="h-4 w-4 mr-2" />
          Help
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <p className="px-2 pt-2 pb-1 text-[11px] text-text-muted leading-snug">
          {pageHelp?.title ? `On ${pageHelp.title} — open contextual help or a full tour.` : 'Contextual help and guided tours.'}
        </p>
        <DropdownMenuItem onClick={openPageHelp}>
          Help on this page
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={runOverview}>
          Run portal tour again
        </DropdownMenuItem>
        {!isAuditor() && (
          <DropdownMenuItem onClick={runPayroll}>
            Run weekly payroll tour again
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={resetForNewStaffOnThisPc} className="text-text-muted">
          Reset tours on this computer
        </DropdownMenuItem>
        <p className="px-2 py-1.5 text-[11px] text-text-muted leading-snug">
          Reset clears progress on this browser so a new colleague sees the intro automatically.
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}